import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import dialogIdentityVerification from 'prismic-translates/dialog-identity-verification.json'
import { useAppSelector } from 'store/hooks'
import { getKycStatusSelector } from 'store/modules/kyc/selectors'
import { getUserAccountIdSelector, softKycFirstNameSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'
import VerifiedIcon from './VerifiedIcon'

const t = getTranslationFromJson([dialogIdentityVerification])

export default function CongratulationMessage() {
  const kycStatus = useAppSelector(getKycStatusSelector)
  const accountId = useAppSelector(getUserAccountIdSelector)
  const userFirstName = useAppSelector(softKycFirstNameSelector)
  const isKycConfirmed = kycStatus === 'confirmed'

  if (!isKycConfirmed) {
    return null
  }

  return (
    <div className={classes.root}>
      <div className={classes.img}>
        <VerifiedIcon />
      </div>
      <p data-test='verifications-congratulations' className={cx('text-center', classes.subTitle)}>
        {t('congratulations')}, {userFirstName}
      </p>
      <p className={cx('text-center', classes.text)}>{t('your_account_verified')}</p>
      <p data-test='verifications-account-id' className={cx('text-center', classes.accountId)}>
        {t('account_id')}: {accountId}
      </p>
    </div>
  )
}
